module.exports = __webpack_public_path__ + "media/images/lp_consultation/common-flow-device-large-84fe104a5759d5840f54f7091972a8aa.png";